import Modals from './components/Modals.js';
import { formSubmitGeneral, fileInput } from "../components/forms";

import gsap from 'gsap';
import CustomEase from 'gsap/CustomEase';

// Custom Ease
gsap.registerPlugin(CustomEase);
CustomEase.create("move-1", "M0,0 C0.178,0.73 0.128,0.584 0.23,0.796 0.256,0.85 0.304,0.938 1,1 ")

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    /* eslint-disable */

    // window.scrollTo(0,0)
    // document.querySelector('.wrap').scrollTo(0,0)
    // document.querySelector('.animsition').scrollTo(0,0)
    // document.body.scrollTo(0,0)

    // Change z-index of intercom
    function editIntercom(addOrRemove) {
      let intercomDiv = document.querySelector('.intercom-app');
      let intercomMessanger = document.querySelector('.intercom-messenger-frame');
      let intercomIframe = document.querySelector('.intercom-launcher-badge-frame');
      let intercomLW = document.querySelector('.intercom-lightweight-app');

      let iframes = document.querySelectorAll('.intercom-app iframe')

      if (intercomDiv != null) {
        // For opacity
        intercomDiv.classList.add('change-opacity');

        // change z-indexs
        if (addOrRemove == "add") {
          intercomDiv.classList.add('adjust-z-index');

          if (intercomLW != null) {
            intercomLW.classList.add('adjust-z-index');
          }
          if (intercomMessanger != null) {
            intercomMessanger.classList.add('adjust-z-index');
          }
          if (intercomIframe != null) {
            intercomIframe.classList.add('adjust-z-index');
          }

          for (let a = 0; a < iframes.length; a++) {
            iframes[a].classList.add('adjust-z-index');
          }
        }
        if (addOrRemove == "remove") {
          intercomDiv.classList.remove('adjust-z-index');

          if (intercomLW != null) {
            intercomLW.classList.remove('adjust-z-index');
          }
          if (intercomMessanger != null) {
            intercomMessanger.classList.remove('adjust-z-index');
          }
          if (intercomIframe != null) {
            intercomIframe.classList.remove('adjust-z-index');
          }

          for (let a = 0; a < iframes.length; a++) {
            iframes[a].classList.remove('adjust-z-index');
          }
        }
      }
    }
    editIntercom('add');

    // Change opacity of intercom - between pages
    function intercomOpacity(value) {
      let intercomDiv = document.querySelector('.intercom-app');
      let intercomApp = document.querySelector('.intercom-lightweight-app');

      if (intercomDiv != null) {
        intercomDiv.style.opacity = value;
      }
      if (intercomApp != null) {
        intercomApp.style.opacity = value;
      }
    }

    var PageInits = {
      smoothScroll: function() {
          const section = document.querySelector('.vs-section');
          // https://npmmirror.com/package/smooth-scrolling

          const smooth = new Smooth({
            // native: true,
            native: true,
            // native: false,
            section: section,
            ease: 0.1,
            
          })

          setTimeout(() => {
            smooth.init();
          }, 1000)

          window.smooth = smooth
      },

      smoothScrollMobile: function() {
          const section = document.querySelector('.vs-section');

          const smooth = new Smooth({
            section: section,
            ease: 0.1,
            noscrollbar: true,
            native: false,
          })

          // smooth.init();
          window.smooth = smooth
      },
    }

    // Smooth Scrol Control - Mobile
    $(window).on('load', function() {
      if ($(window).width() >= 1025) {
        PageInits.smoothScroll();
      }
      else {
        // Mobile
        PageInits.smoothScrollMobile();
      }

      generalAnchors()
    })
    $(window).on('resize', function() {
      if ($(window).width() >= 1025) {
        document.querySelector('.vs-scroll-view').style.height = `${document.querySelector('.vs-section').getBoundingClientRect().height}px`
      }
      else {
        // Mobile
        // PageInits.smoothScrollMobile();
      }
    })

    // Refresh to smooth scroll
    const desktop = window.matchMedia('screen and (min-width: 1025px)');
    const mobile = window.matchMedia('screen and (max-width: 1024px)');

    desktop.addListener(function (e) {
      if (e.matches) {
        location.reload();
      }
    });

    mobile.addListener(function (e) {
      if (e.matches) {
        location.reload();
      }
    });


    // Jquery easing
    jQuery.easing.jswing = jQuery.easing.swing;
    jQuery.extend(jQuery.easing, {
        def: "easeOutQuad",
        swing: function(e, f, a, h, g) {
            return jQuery.easing[jQuery.easing.def](e, f, a, h, g)
        },
        easeInQuad: function(e, f, a, h, g) {
            return h * (f /= g) * f + a
        },
        easeOutQuad: function(e, f, a, h, g) {
            return -h * (f /= g) * (f - 2) + a
        },
        easeInOutQuad: function(e, f, a, h, g) {
            if ((f /= g / 2) < 1) {
                return h / 2 * f * f + a
            }
            return -h / 2 * ((--f) * (f - 2) - 1) + a
        },
        easeInCubic: function(e, f, a, h, g) {
            return h * (f /= g) * f * f + a
        },
        easeOutCubic: function(e, f, a, h, g) {
            return h * ((f = f / g - 1) * f * f + 1) + a
        },
        easeInOutCubic: function(e, f, a, h, g) {
            if ((f /= g / 2) < 1) {
                return h / 2 * f * f * f + a
            }
            return h / 2 * ((f -= 2) * f * f + 2) + a
        },
    });

     /* eslint-enable */

    // Sticky Navigation

    function smoothWrapTransformCheck() {
       let bwsHeader = document.getElementById('bws-header');
       var wrapValue = document.getElementById('wrap').getBoundingClientRect().top;

       if ( wrapValue <= -134 ) {
        bwsHeader.classList.add('sticky');

        $('#nav-line').addClass('sticky');

       } else if (wrapValue >= -134) {
        bwsHeader.classList.remove('sticky');

        $('#nav-line').removeClass('sticky');
       }
    }

    setInterval(function() {
        smoothWrapTransformCheck();
    }, 500);


    window.onload = function() {
      navigationLine();
      initiNavigationLine();
    };

    // Navigation Line
    let line = document.getElementById('nav-line');

    // Nav Indication Line - follow
    function navigationLine() {
        // On hover gets li width and position and updates nav line
        $('#menu-main-navigation li').hover(function() {
            let el = this;

            // Desktop sub a hover and not li
            if (this.classList.contains('desktop-sub-li')) {
              el = this.children[0]
            }
            let current_Width = el.offsetWidth;
            let current_Position = el.getBoundingClientRect();

            $(line).stop().animate({
                width: current_Width,
                left: current_Position.x,
                easing: 'easeInSine',
            });

        });
    }

    // Sets navigation line
    function initiNavigationLine() {
        // Delayed to allow for page load
        setTimeout(function() {
            // Get current nav items width and position
            // let current_Nav_Item = document.querySelectorAll('.desktop-main-nav .current_page_item a');
          let current_Nav_Item = document.querySelectorAll('.desktop-main-nav .active-page a');
            if (current_Nav_Item.length > 0) {
                let current_Nav_Item_Width = current_Nav_Item[0].offsetWidth;
                let current_Nav_Item_Left_Position = current_Nav_Item[0].getBoundingClientRect();

                // Sets line nav values
                line.style.width = current_Nav_Item_Width + 'px';
                $(line).css('left', current_Nav_Item_Left_Position.x);
            }
        }, 650);
    }

    function resetNavLine() {
      // let current_Nav_Item = document.querySelectorAll('.desktop-main-nav .current_page_item a');
      let current_Nav_Item = document.querySelectorAll('.desktop-main-nav .active-page a');
      if (current_Nav_Item.length > 0) {
        let current_Nav_Item_Width = current_Nav_Item[0].offsetWidth;
        let current_Nav_Item_Left_Position = current_Nav_Item[0].getBoundingClientRect();

        // Sets line nav value back to current page item
        $(line).stop().animate({
            width: current_Nav_Item_Width,
            left: current_Nav_Item_Left_Position.x,
            easing: 'easeInSine',
        });
      }
    }

    // Sets line to current menu item on mouse leave
    document.getElementById("bws-header").addEventListener("mouseleave", resetNavLine);

    // Window Resize - Edit nav line
    window.addEventListener('resize', resetNavLine);



    //Animsition page loader
    $(document).ready(function() {
      $(".animsition").animsition({
          inClass: 'fade-in',
          outClass: 'fade-out',
          inDuration: 1800,
          outDuration: 800,
          // inDuration: 1800,
          // outDuration: 1500,
          // linkElement: 'a',
        linkElement: 'a:not([target="_blank"]):not([href^="#"]):not(.share-link):not(.no-animsition):not(.bws-header .menu-item-has-children > a)',
          // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
          loading: true,
          loadingParentElement: 'body', //animsition wrapper element
          loadingClass: 'bws-loading',
          // loadingClass: '',
          // loadingInner: '', // e.g ''
          loadingInner: '<div class="loader-inner"></div>', // e.g ''
          timeout: false,
          timeoutCountdown: 5000,
          onLoadEvent: true,
          browser: [ 'animation-duration', '-webkit-animation-duration'],
          // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
          // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
          overlay : false,
          overlayClass : 'animsition-overlay-slide',
          overlayParentElement : 'body',
          transition: function(url){ window.location.href = url; },
        });


        $(".animsition").on('animsition.inStart', function(){
          intercomOpacity(1);
        })

        $(".animsition").on('animsition.inEnd', function(){
          intercomOpacity(1);
        })

        $(".animsition").on('animsition.outStart', function(){
          intercomOpacity(0);
        })
        $(".animsition").on('animsition.outEnd', function(){
          intercomOpacity(0);
        })
      });

    /* eslint-disable */
    if ($('#home-slider-one').length) {
            setTimeout(function() {
            var homeSliderOne = $('#home-slider-one').lightSlider({
                item: 1,
                autoWidth: false,
                slideMove: 1, // slidemove will be 1 if loop is true

                // mode: 'fade',
                mode: 'slide',
                useCSS: true,

                speed: 800, //ms'
                auto: false,
                loop: false,
                slideEndAnimation: false,
                // pause: 2000,

                keyPress: false,
                controls: false,
                prevHtml: '',
                nextHtml: '',

                rtl: false,
                adaptiveHeight: false,
                slideMargin: 0,

                pager: true,
                gallery: false,
                thumbMargin: 30,
                currentPagerPosition: 'left',

                enableTouch: false,
                enableDrag: false,
                freeMove: false,
                swipeThreshold: 1,

                responsive : [ {
                  breakpoint: 768,
                  settings: {
                      slideMargin: 60,
                      enableTouch: true,
                      enableDrag: true,
                    },
                }],

                onBeforeStart: function (el) { },
                onSliderLoad: function (el) { },
                onBeforeSlide: function (el) {
                  $('#home-section-three #home-slider-one-wrapper li .image-wrapper').addClass('active');
                },
                onAfterSlide: function (el) {
                  $('#home-section-three #home-slider-one-wrapper li .image-wrapper').removeClass('active');

                  let prevArrow = document.querySelector('#home-section-three .bws-arrow.prev');
                  let nextArrow = document.querySelector('#home-section-three .bws-arrow.next');
                  let currentSlide = $('#home-section-three #home-slider-one-wrapper .bws-slide.active').data('count');

                  if (currentSlide == 1) {
                    prevArrow.classList.add('disabled');
                    nextArrow.classList.remove('disabled');
                  } else if (currentSlide == pagerItems) {
                    prevArrow.classList.remove('disabled');
                    nextArrow.classList.add('disabled');
                  } else {
                    prevArrow.classList.remove('disabled');
                    nextArrow.classList.remove('disabled');
                  }
                },
                onBeforeNextSlide: function (el) {},
                onBeforePrevSlide: function (el) {}
            });


            let pagerItems = $('#home-section-three #home-slider-one-wrapper .lightSlider li.bws-slide').length;

            let currentSlide = $('.bws-slide.active').data('count', 1);

            $('#home-section-three .bws-pager .bws-arrow').click(function(e) {
              e.preventDefault();

              // Arrows move the slider next or prev
              if ($(this).hasClass('next')) {
                homeSliderOne.goToNextSlide();


              } else if ($(this).hasClass('prev')) {
                homeSliderOne.goToPrevSlide();

              }
            });
        }, 500);
    }

    if ($('#home-slider-two').length) {
            setTimeout(function() {
            var homeSliderTwo = $('#home-slider-two').lightSlider({
                item: 1,
                autoWidth: false,
                slideMove: 1, // slidemove will be 1 if loop is true

                // mode: 'fade',
                mode: 'slide',
                useCSS: true,

                speed: 800, //ms'
                auto: false,
                loop: false,
                slideEndAnimation: false,
                // pause: 2000,

                keyPress: false,
                controls: false,
                prevHtml: '',
                nextHtml: '',

                rtl: false,
                adaptiveHeight: false,

                pager: true,
                gallery: false,
                thumbMargin: 0,
                slideMargin: 0,
                currentPagerPosition: 'left',

                enableTouch: false,
                enableDrag: false,
                freeMove: false,
                swipeThreshold: 1,

                responsive : [ {
                  breakpoint: 768,
                  settings: {
                      slideMargin: 60,
                      enableTouch: true,
                      enableDrag: true,
                    },
                }],

                onBeforeStart: function (el) { },
                onSliderLoad: function (el) { },
                onBeforeSlide: function (el) {
                  $('#home-section-three #home-slider-two-wrapper li .image-wrapper').addClass('active');
                  // $('#home-section-three li img').addClass('transition');
                },
                onAfterSlide: function (el) {
                  $('#home-section-three #home-slider-two-wrapper li .image-wrapper').removeClass('active');
                  // $('#home-section-three li img').removeClass('transition');

                  let prevArrow = document.querySelector('#home-section-three .bws-arrow.prev');
                  let nextArrow = document.querySelector('#home-section-three .bws-arrow.next');
                  let currentSlide = $('#home-section-three #home-slider-two-wrapper .bws-slide.active').data('count');

                  if (currentSlide == 1) {
                    prevArrow.classList.add('disabled');
                    nextArrow.classList.remove('disabled');
                  } else if (currentSlide == pagerItems) {
                    prevArrow.classList.remove('disabled');
                    nextArrow.classList.add('disabled');
                  } else {
                    prevArrow.classList.remove('disabled');
                    nextArrow.classList.remove('disabled');
                  }
                },
                onBeforeNextSlide: function (el) {},
                onBeforePrevSlide: function (el) {}
            });


            let pagerItems = $('#home-section-three #home-slider-two-wrapper .lightSlider li.bws-slide').length;

            let currentSlide = $('.bws-slide.active').data('count', 1);

            $('#home-section-three .bws-pager .bws-arrow').click(function(e) {
              e.preventDefault();

              // Arrows move the slider next or prev
              if ($(this).hasClass('next')) {
                homeSliderTwo.goToNextSlide();


              } else if ($(this).hasClass('prev')) {
                homeSliderTwo.goToPrevSlide();

              }
            });
        }, 500);
    }

    if ($('#home-slider-three').length) {
            setTimeout(function() {
            var homeSliderTwo = $('#home-slider-three').lightSlider({
                item: 1,
                autoWidth: false,
                slideMove: 1, // slidemove will be 1 if loop is true

                // mode: 'fade',
                mode: 'slide',
                useCSS: true,

                speed: 800, //ms'
                auto: false,
                loop: false,
                slideEndAnimation: false,
                // pause: 2000,

                keyPress: false,
                controls: false,
                prevHtml: '',
                nextHtml: '',

                rtl: false,
                adaptiveHeight: false,

                pager: true,
                gallery: false,
                thumbMargin: 0,
                slideMargin: 60,
                currentPagerPosition: 'left',

                enableTouch: true,
                enableDrag: true,
                freeMove: false,
                swipeThreshold: 1,

                responsive : [ { }],

                onBeforeStart: function (el) { },
                onSliderLoad: function (el) { },
                onBeforeSlide: function (el) {
                  $('#home-section-three #home-slider-three-wrapper li .image-wrapper').addClass('active');
                  // $('#home-section-three li img').addClass('transition');
                },
                onAfterSlide: function (el) {
                  $('#home-section-three #home-slider-three-wrapper li .image-wrapper').removeClass('active');
                  // $('#home-section-three li img').removeClass('transition');

                  let prevArrow = document.querySelector('#home-section-three .bws-arrow.prev');
                  let nextArrow = document.querySelector('#home-section-three .bws-arrow.next');
                  let currentSlide = $('#home-section-three #home-slider-three-wrapper .bws-slide.active').data('count');

                  if (currentSlide == 1) {
                    prevArrow.classList.add('disabled');
                    nextArrow.classList.remove('disabled');
                  } else if (currentSlide == pagerItems) {
                    prevArrow.classList.remove('disabled');
                    nextArrow.classList.add('disabled');
                  } else {
                    prevArrow.classList.remove('disabled');
                    nextArrow.classList.remove('disabled');
                  }
                },
                onBeforeNextSlide: function (el) {},
                onBeforePrevSlide: function (el) {}
            });


            let pagerItems = $('#home-section-three #home-slider-three-wrapper .lightSlider li.bws-slide').length;

            let currentSlide = $('.bws-slide.active').data('count', 1);

            $('#home-section-three .bws-pager .bws-arrow').click(function(e) {
              e.preventDefault();

              // Arrows move the slider next or prev
              if ($(this).hasClass('next')) {
                homeSliderTwo.goToNextSlide();


              } else if ($(this).hasClass('prev')) {
                homeSliderTwo.goToPrevSlide();

              }
            });
        }, 500);
    }

    /* eslint-enable */

    // ==============================
    // Parallax Scroll
    // ==============================
    /* eslint-disable */

    $(function() {
        ParallaxScroll.init();
    });
    //PARALLAX
    var ParallaxScroll = {
    /* PUBLIC VARIABLES */
    showLogs: false,
    round: 1000,

    /* PUBLIC FUNCTIONS */
    init: function () {
        this._log("init");
        if (this._inited) {
          this._log("Already Inited");
          this._inited = true;
          return;
        }
        this._requestAnimationFrame = (function () {
          return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function ( /* function */ callback, /* DOMElement */ element) {
              window.setTimeout(callback, 1000 / 60);
            };
        })();
        this._onScroll(true);
      },

      /* PRIVATE VARIABLES */
      _inited: false,
      _properties: ['x', 'y', 'z', 'rotateX', 'rotateY', 'rotateZ', 'scaleX', 'scaleY', 'scaleZ', 'scale'],
      _requestAnimationFrame: null,

      /* PRIVATE FUNCTIONS */
      _log: function (message) {
        if (this.showLogs) console.log("Parallax Scroll / " + message);
      },
      _onScroll: function (noSmooth) {
        var scroll = $(document).scrollTop();
        var windowHeight = $(window).height();
        this._log("onScroll " + scroll);
        $("[data-parallax]").each($.proxy(function (index, el) {
          var $el = $(el);
          var properties = [];
          var applyProperties = false;
          var style = $el.data("style");
          if (style == undefined) {
            style = $el.attr("style") || "";
            $el.data("style", style);
          }
          var datas = [$el.data("parallax")];
          var iData;
          for (iData = 2;; iData++) {
            if ($el.data("parallax" + iData)) {
              datas.push($el.data("parallax-" + iData));
            } else {
              break;
            }
          }
          var datasLength = datas.length;
          for (iData = 0; iData < datasLength; iData++) {
            var data = datas[iData];
            var scrollFrom = data["from-scroll"];
            if (scrollFrom == undefined) scrollFrom = Math.max(0, $(el).offset().top - windowHeight);
            scrollFrom = scrollFrom | 0;
            var scrollDistance = data["distance"];
            var scrollTo = data["to-scroll"];
            if (scrollDistance == undefined && scrollTo == undefined) scrollDistance = windowHeight;
            scrollDistance = Math.max(scrollDistance | 0, 1);
            var easing = data["easing"];
            var easingReturn = data["easing-return"];
            if (easing == undefined || !$.easing || !$.easing[easing]) easing = null;
            if (easingReturn == undefined || !$.easing || !$.easing[easingReturn]) easingReturn = easing;
            if (easing) {
              var totalTime = data["duration"];
              if (totalTime == undefined) totalTime = scrollDistance;
              totalTime = Math.max(totalTime | 0, 1);
              var totalTimeReturn = data["duration-return"];
              if (totalTimeReturn == undefined) totalTimeReturn = totalTime;
              scrollDistance = 1;
              var currentTime = $el.data("current-time");
              if (currentTime == undefined) currentTime = 0;
            }
            if (scrollTo == undefined) scrollTo = scrollFrom + scrollDistance;
            scrollTo = scrollTo | 0;
            var smoothness = data["smoothness"];
            if (smoothness == undefined) smoothness = 30;
            smoothness = smoothness | 0;
            if (noSmooth || smoothness == 0) smoothness = 1;
            smoothness = smoothness | 0;
            var scrollCurrent = scroll;
            scrollCurrent = Math.max(scrollCurrent, scrollFrom);
            scrollCurrent = Math.min(scrollCurrent, scrollTo);
            if (easing) {
              if ($el.data("sens") == undefined) $el.data("sens", "back");
              if (scrollCurrent > scrollFrom) {
                if ($el.data("sens") == "back") {
                  currentTime = 1;
                  $el.data("sens", "go");
                } else {
                  currentTime++;
                }
              }
              if (scrollCurrent < scrollTo) {
                if ($el.data("sens") == "go") {
                  currentTime = 1;
                  $el.data("sens", "back");
                } else {
                  currentTime++;
                }
              }
              if (noSmooth) currentTime = totalTime;
              $el.data("current-time", currentTime);
            }
            this._properties.map($.proxy(function (prop) {
              var defaultProp = 0;
              var to = data[prop];
              if (to == undefined) return;
              if (prop == "scale" || prop == "scaleX" || prop == "scaleY" || prop == "scaleZ") {
                defaultProp = 1;
              } else {
                to = to | 0;
              }
              var prev = $el.data("_" + prop);
              if (prev == undefined) prev = defaultProp;
              var next = ((to - defaultProp) * ((scrollCurrent - scrollFrom) / (scrollTo - scrollFrom))) + defaultProp;
              var val = prev + (next - prev) / smoothness;
              if (easing && currentTime > 0 && currentTime <= totalTime) {
                var from = defaultProp;
                if ($el.data("sens") == "back") {
                  from = to;
                  to = -to;
                  easing = easingReturn;
                  totalTime = totalTimeReturn;
                }
                val = $.easing[easing](null, currentTime, from, to, totalTime);
              }
              val = Math.ceil(val * this.round) / this.round;
              if (val == prev && next == to) val = to;
              if (!properties[prop]) properties[prop] = 0;
              properties[prop] += val;
              if (prev != properties[prop]) {
                $el.data("_" + prop, properties[prop]);
                applyProperties = true;
              }
            }, this));
          }
          if (applyProperties) {
            if (properties["z"] != undefined) {
              var perspective = data["perspective"];
              if (perspective == undefined) perspective = 800;
              var $parent = $el.parent();
              if (!$parent.data("style")) $parent.data("style", $parent.attr("style") || "");
              $parent.attr("style", "perspective:" + perspective + "px; -webkit-perspective:" + perspective + "px; " + $parent.data("style"));
            }
            if (properties["scaleX"] == undefined) properties["scaleX"] = 1;
            if (properties["scaleY"] == undefined) properties["scaleY"] = 1;
            if (properties["scaleZ"] == undefined) properties["scaleZ"] = 1;
            if (properties["scale"] != undefined) {
              properties["scaleX"] *= properties["scale"];
              properties["scaleY"] *= properties["scale"];
              properties["scaleZ"] *= properties["scale"];
            }
            var translate3d = "translate3d(" + (properties["x"] ? properties["x"] : 0) + "px, " + (properties["y"] ? properties["y"] : 0) + "px, " + (properties["z"] ? properties["z"] : 0) + "px)";
            var rotate3d = "rotateX(" + (properties["rotateX"] ? properties["rotateX"] : 0) + "deg) rotateY(" + (properties["rotateY"] ? properties["rotateY"] : 0) + "deg) rotateZ(" + (properties["rotateZ"] ? properties["rotateZ"] : 0) + "deg)";
            var scale3d = "scaleX(" + properties["scaleX"] + ") scaleY(" + properties["scaleY"] + ") scaleZ(" + properties["scaleZ"] + ")";
            var cssTransform = translate3d + " " + rotate3d + " " + scale3d + ";";
            this._log(cssTransform);
            $el.attr("style", "transform:" + cssTransform + " -webkit-transform:" + cssTransform + " " + style);
          }
        }, this));
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame($.proxy(this._onScroll, this, false));
        } else {
          this._requestAnimationFrame($.proxy(this._onScroll, this, false));
        }
      }
    };



    // Footer Year
    // let date = new Date();
    // let year = date.getFullYear();
    // let footerYear = document.getElementById('year');
    // footerYear.textContent = year;

    /* eslint-enable */

    // Mobile Nav trigger
    function openMobileNav() {
      editIntercom('remove');
      window.smooth.off()

      document.getElementById('mobile-navigation').classList.add('active');
      document.getElementById('mobile-nav-trigger').classList.add('active');
      document.getElementById('bws-header').classList.add('nav-open');
      document.querySelector('body').classList.add('of-h-2');
      document.querySelector('html').classList.add('of-h-2');
    }

    function closeMobileNav() {
        document.getElementById('mobile-navigation').classList.add('out');
        document.getElementById('bws-header').classList.add('out');
        document.getElementById('bws-header').classList.remove('nav-open');
        document.querySelector('html').classList.remove('of-h-2');
        document.querySelector('body').classList.remove('of-h-2');

      setTimeout(function() {
        document.getElementById('mobile-navigation').classList.remove('active', 'out');
        document.getElementById('mobile-nav-trigger').classList.remove('active');
        document.getElementById('bws-header').classList.remove('out');

        window.smooth.on()
        editIntercom('add');
      }, 600);

    }

    // Mobile Nav - In and Out
    document.getElementById("mobile-nav-trigger").addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      let navigation_trigger = document.getElementById("mobile-nav-trigger");

      // If Nav is open - close it
      if (navigation_trigger.classList[1] == 'active' ) {
        closeMobileNav();
      }

      // If Nav isn't open - open it
      else if (navigation_trigger.classList[0] == 'nav-trigger' ) {
        openMobileNav();
      }
    });

    // // Allows forms to validate and not trigger - Smooth State
    let get_forms = document.querySelectorAll('form');

    for(let a = 0; a < get_forms.length; a++) {
      get_forms[a].classList.add('wp-link');
    }

    /* eslint-disable 
    document.addEventListener( 'wpcf7mailfailed', function(event) {
      cf7_form_submit(event, ' .failed');
    }, false );

    // On mail sent
    document.addEventListener( 'wpcf7submit', function(event) {
      // If there are form errors - don't submit
      if (event.detail.status == "validation_failed") {
        return;
      } else {
        cf7_form_submit(event, ' .success');
      }
    }, false );

    function cf7_form_submit(event, class_name ) {

      let formId = event.target.querySelector('.form').id;
      formId = '#' + formId;

      $(formId + ' .form-content-wrap').animate({
          opacity: 0,
          duration: 450,
          easing: 'easeInOutQuad',
          height: 0,
        });

      $(formId + ' .form-response-wrap').addClass('active');
      $(formId + ' .form-response-wrap' + class_name ).addClass('active');
    }

    // WCF7 Failed Message - refresh page
    jQuery('.failed .reload').on('click', function() {
        location.reload();
    });

    // File Upload
    /*
    $('input[type=file]').on('change', function() {
      let fileName = this.value.split('\\');

      if (fileName == '') {
        this.parentNode.nextSibling.nextSibling.innerHTML = '<p>No File Choosen</p>';
      } else {
        this.parentNode.nextSibling.nextSibling.innerHTML = '<p>' + fileName[fileName.length - 1] + '</p>';
      }

    });
    */


    /* eslint-disable */
    var le_scroll = null;
    /* esline-enable */

    // Modal - Active
    $('a.video-button, a.modal-button').click(function(e) {
        e.preventDefault();
        e.stopPropagation();

        let modalId = this.id;

        smooth.off()
        
      if (window.innerWidth <= 1024) {
        document.documentElement.classList.add('of-h')
        document.body.classList.add('of-h')
      }

        $('.bws-modal[id="' + modalId + '"]').addClass('active');

      // console.log('common modal', $('.bws-modal[id="' + modalId + '"]'));

        // Checks if modal has iframe - then starts video
        if ($('.bws-modal.active[id=' + modalId + ']').hasClass('video')) {
            $('.bws-modal.video.active iframe#' + modalId)[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }
          // document.querySelector('body').classList.add('of-h');
          // document.querySelector('html').classList.add('of-h');
        // document.querySelector('.animsition').style.pointerEvents = 'none'

        // le_scroll.off();
    });

    // Modal - Close
    $('.close-button').click(function(e) {
        e.preventDefault();

        smooth.on()

      if (window.innerWidth <= 1024) {
        document.documentElement.classList.remove('of-h')
        document.body.classList.remove('of-h')
      }

        let modalId = this.id;
        let activeModal = document.querySelector('.bws-modal.active');

        // $('html,body').addClass('of-h');
       let html_e = document.querySelector('html');
       let body_e = document.querySelector('body');
       let close = document.querySelectorAll('.modal-button');
        //  html_e.classList.remove('of-h');
        //  body_e.classList.remove('of-h');
        // document.querySelector('.animsition').style.pointerEvents = 'all'

        // Checks if modal has iframe - then pauses video
        if ($('.bws-modal.active[id=' + modalId + ']').hasClass('video')) {
            $('.bws-modal.video.active iframe#' + modalId)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
        // Css out
        activeModal.classList.add('out');

        // no pointer events until closing modal animation is done
        for (let a = 0; a < close.length; a++) {
          close[a].classList.add('no-click');
        }

        // Removes all active classes
        setTimeout(function() {
            activeModal.classList.remove('out', 'active');
            for (let a = 0; a < close.length; a++) {
              close[a].classList.remove('no-click');
            }
        }, 500);
    });

    // Video Button Hover
    // $('.bws-button-wrapper.video-wrapper').on({
    //     mouseenter: function() {
    //         if (! this.classList.contains('change-before-out')) {
    //             this.classList.add('change-before-out');
    //         }
    //     },
    //     mouseleave: function() {
    //         setTimeout(function() {
    //             $('.bws-button-wrapper.video-wrapper').removeClass('change-before-out');
    //         }, 300);
    //     },
    // });

    /* jquery hover */
    // $('.video-wraps').hover(function(e) {
    //   $(this).addClass('entered');
    //   $(".ball").addClass('moving');
    // }, function(a) {
    //   $(this).removeClass('entered');
    //   $(".ball").removeClass('moving');
    // });

    /* pure JS mouse following cursor */
    // if ($('.video-preview-large').length) {
    //   const videoWrapper = document.querySelector(".video-wraps");
    //   const ball = document.querySelector(".ball");

    //   // const wrapOffsetY = videoWrapper.getBoundingClientRect().top + window.scrollY;
    //   const wrapOffsetY = videoWrapper.getBoundingClientRect().x + window.scrollY;
    //   const wrapOffsetX = videoWrapper.getBoundingClientRect().left;

    //   let mouseX = 0;
    //   let mouseY = 0;

    //   let ballX = 0;
    //   let ballY = 0;

    //   let speed = 0.15;

    //   function animate() {
    //     let distX = mouseX - ballX;
    //     let distY = mouseY - ballY;

    //     ballX = ballX + (distX * speed);
    //     ballY = ballY + (distY * speed);

    //     ball.style.left = ballX + "px";
    //     ball.style.top = ballY + "px";

    //     requestAnimationFrame(animate);
    //   }
    //   animate();

    //   videoWrapper.addEventListener("mousemove", function (event) {

    //     mouseX = event.pageX - wrapOffsetX;
    //     // mouseY = event.pageY - wrapOffsetY;
    //     mouseY = event.pageY - wrapOffsetY - ((ball.getBoundingClientRect().height) / 4);
    //   });
    // }

    function generalAnchors() {
      // anchor links
      $('.anchor-link').on('click', function (e) {
        e.preventDefault();

        // Get href
        let targetId = this.href;

        // Slit href - then get last part
        let lastPart = targetId.split('/');
        let arrLength = lastPart.length - 1;
        let getLastPart = lastPart[arrLength];
        getLastPart = '#' + getLastPart
        let header = document.querySelector('#bws-header').getBoundingClientRect().height - 20

        // Page ID location
        // let toPageLocation = $('#' + getLastPart).offset().top - 100;
        // let toPageLocationMobile = $('#' + getLastPart).offset().top - 80;

        // Halved to offset smooth scroll
        // let halfLocation = (toPageLocation / 1.7);
        // let halfLocationMobile = toPageLocationMobile;

        // Page scroll animation
        /*
        if ( $(window).width() >= 1024) {
          $('html,body').stop().animate({
              scrollTop: halfLocation,
              easing: 'easeInOutQuad',
          }, 800);
        } else {
          $('html,body').stop().animate({
              scrollTop: halfLocationMobile,
              easing: 'easeInOutQuad',
          }, 800);
        }
        */

        let v = $(getLastPart).offset().top - (header)

        if (window.innerWidth >= 1025) {
          smooth.scrollTo(v)
        } else {
          gsap.to(window, {
            scrollTo: v,
          })
        }

      });
    }

    // Modals One - 2021
    if (document.querySelectorAll('.js-modal-button').length > 0) {
      // eslint-disable-next-line
      setTimeout(() => {
        let allModals = new Modals();
      }, 2000)
    }

    // Modal Message
    if (document.body.classList.contains('home') &&
      document.querySelector('#general-modal-two-content').dataset.toggle == 1) {
      // eslint-disable-next-line
      let allModals = new Modals();

      // Add modal call to Modal Object
      allModals.timedModalCta = (_contentId, _modalId, _contentWidth) => {

        // Pass arguments to function
        allModals.openModal(undefined, _contentId, _modalId, _contentWidth);
      }

      setTimeout(() => {
        smooth.off()

        if (window.innerWidth <= 1024) {
          document.documentElement.classList.add('of-h')
          document.body.classList.add('of-h')
        }
        
        // console.log(window.smooth.off());
        // smooth.destroy()
        // allModals.timedModalCta('covid-message', 'general-modal', 'col-lg-8 col-md-8 col-sm-10 col-xs-10');
        allModals.timedModalCta('general-modal-two-content', 'general-modal-two', 'col-lg-8 col-md-8 col-sm-10 col-xs-10');
      }, 3000);

    }

    if (document.body.classList.contains('page-contact-data')) {
      formSubmitGeneral('careers-form', 'careers_modal_form', 'careers form')
      fileInput()
    }

    if (document.body.classList.contains('page-the-salon-data')) {
      setTimeout(() => {
        formSubmitGeneral('the-salon-sign-up', 'newsletter_sign_up', 'the salon newsletter form')

        formSubmitGeneral('careers-form', 'careers_modal_form', 'careers form')
        fileInput()
      }, 1000)
    }

    // Home subscribe
    if (document.body.classList.contains('page-home-data')) {
      formSubmitGeneral('home-salon-sign-up', 'newsletter_sign_up', 'home newsletter form')

      formSubmitGeneral('careers-form', 'careers_modal_form', 'careers form')
      fileInput()
    }

    if (document.body.classList.contains('page-services-data')) {
      formSubmitGeneral('services-sign-up', 'newsletter_sign_up', 'services newsletter form')
    }

    if (document.body.classList.contains('page-experience-data')) {
      formSubmitGeneral('experience-sign-up', 'newsletter_sign_up', 'experience newsletter form')
    }

    if (document.body.classList.contains('page-template-template-salon-location')) {
      formSubmitGeneral('sl-salon-sign-up', 'newsletter_sign_up', 'salon location newsletter form')
    }

    // Book an appointment
    formSubmitGeneral('modal-appointment-form', 'appointment_sign_up', 'book an appointment form')

    // $('.bws-header .menu-item-has-children a').forEach(a => {
    //   a.classList.add('no-animsition')
    //   a.addEventListener('click', event => {
    //     event.preventDefault()
    //   })

      if (document.querySelectorAll('#mobile-navigation .mobile-accordion-link').length > 0) {
        let links = Array.from(document.querySelectorAll('#mobile-navigation .mobile-top-level-link.mobile-accordion-link'))

        links.forEach(l => {
          l.addEventListener('click', event => {
            event.preventDefault()

            let el = event.target
            let menu = el.closest('li').querySelector('.sub-menu-accordion')
            let svg = el.querySelector('.accordion-link svg')

            if (! el.classList.contains('active')) {
              if ( ! el.classList.contains('is-animating')) {
                openAccordion(el, menu, svg)
              }
            }
            else if (el.classList.contains('active')) {
              if ( ! el.classList.contains('is-animating')) {
                closeAccordion(el, menu, svg)
              }
            }
          })
        })
      }

      function openAccordion(el, menu, svg) {
        el.classList.add('is-animating')
        el.classList.add('active')
        // el.closest('li').querySelector('.sub-menu-accordion')
        
        let open = gsap.timeline();
        open.fromTo(menu, {
          height: 0,
        }, {
          height: menu.children[0].getBoundingClientRect().height,
          duration: 0.4,
          ease: "power2.out",
          onComplete: () => {
            el.classList.remove('is-animating')
          },
        })
        open.to(svg, {
          rotate: 45,
          duration: 0.4,
          ease: "power2.out",
        }, '-=0.4')
      }

      function closeAccordion(el, menu, svg) {
        el.classList.add('is-animating')
        
        // el.closest('li').querySelector('.sub-menu-accordion')
        
        let open = gsap.timeline();
        open.fromTo(menu, {
          height: menu.children[0].getBoundingClientRect().height,
        }, {
          height: 0,
          duration: 0.4,
          ease: "power3.out",
          onComplete: () => {
            el.classList.remove('active')
            el.classList.remove('is-animating')
          },
        })
        open.to(svg, {
          rotate: 0,
          duration: 0.4,
          ease: "power2.out",
        }, '-=0.4')
        
      }

    function changeActivePageLink() {
      // Get current page link
      let page = window.location.href;

      // Get nav links - desktop and mobile
      let mobileLinks = document.querySelectorAll('.mobile-main-nav a');
      let desktopLinks = document.querySelectorAll('.bws-nav.desktop a');

      // desktopLinks.forEach((a, i) => { changeActiveLink(a, page, i, desktopLinks, mobileLinks) })
      // mobileLinks.forEach((a, i) => { changeActiveLink(a, page, i, desktopLinks, mobileLinks) })
      mobileLinks.forEach((a, i) => { changeActiveLink(a, page, i, mobileLinks, desktopLinks) })
      desktopLinks.forEach((a, i) => { changeActiveLink(a, page, i, mobileLinks, desktopLinks) })
    }
    changeActivePageLink()

    // function changeActiveLink(a, page, i, desktopLinks, mobileLinks) {
    function changeActiveLink(a, page, i, mobileLinks, desktopLinks) {
      if (a.href === page) {
        a.parentElement.classList.add('active-page');
        if (a.closest('.menu-item-has-children') != null) {
          a.closest('.menu-item-has-children').children[0].classList.add('active-page')
        }

        // If sub menu - add to parent link
        if (a.classList.contains('sub-menu-link')) {
          a.closest('.menu-item-has-children').classList.add('active-page')
        }
      } 
    }

    function desktopSubNav() {
      if (document.querySelectorAll('.bws-nav .menu-item-has-children').length > 0) {
        let sub = Array.from(document.querySelectorAll('.bws-nav.desktop .menu-item-has-children'))
        
        sub.forEach(s => {
          s.addEventListener('mouseenter', event => {
            if (window.innerWidth > 1024) {
              event.target.classList.add('active')
            }
          })

          s.addEventListener('mouseleave', event => {
            if (window.innerWidth > 1024) {
              event.target.classList.remove('active')
            }
          })
        })

      }
    }
    desktopSubNav()

    // })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js